import React, { useCallback } from "react";
import { HowAddNewAlbum } from "./articles/HowAddNewAlbum";
import { HowAddTracksInAlbum } from "./articles/HowAddTracksInAlbum";
import { HowRevokeAlbum } from "./articles/HowRevokeAlbum";
import { HowRevokeTrack } from "./articles/HowRevokeTrack";
import { HowEditTrackInAlbum } from "./articles/HowEditTrackInAlbum";
import { HowAddTrackInAlbum } from "./articles/HowAddTrackInAlbum";
import { HowFindLinkOnAlbum } from "./articles/HowFindLinkOnAlbum";
import { VkClipsAndStories } from "./articles/VkClipsAndStories";
import { HowUploadVideo } from "./articles/HowUploadVideo";
import { HowAddLyrics } from "./articles/HowAddLyrics";
import { HowRevokeLyrics } from "./articles/HowRevokeLyrics";
import { StatisticsInfo } from "./articles/StatisticsInfo";
import { Faq } from "./articles/Faq";
import { useTranslation } from "../../hooks/useTranslation";
import { useTitle } from "../../hooks/use-title";
import { HowSpecifyArtistCardWhenPublish } from "./articles/HowSpecifyArtistCardWhenPublish";
import { HowCreateNewArtistCard } from "./articles/HowCreateNewArtistCard";
import { HowActionsWithRights } from "./articles/rights/HowActionsWithRights";

const SIDEBAR_ITEMS = [
  {
    key: "HowAddNewAlbum",
    title: "Как добавить новый альбом"
  },
  {
    key: "HowAddTracksInAlbum",
    title: "Как добавить треки в альбом",
    nested: [
      {
        key: "HowAddTracksInAlbumMainInformation",
        title: "Основная информация"
      },
      {
        key: "HowAddTracksInAlbumFinancialInformation",
        title: "Финансовые модели"
      }
    ]
  },
  {
    key: "HowActionsWithRights",
    title: "Авторские права",
    nested: [
      {
        key: "HowAddRightsOnRelease",
        title: "Как добавить авторские права на релизы"
      },
      {
        key: "HowGroupAddRightsOnRelease",
        title: "Массовое добавление авторских прав"
      },
      {
        key: "HowRevokeRightsOnRelease",
        title: "Как изъять авторские права"
      }
    ]
  },
  {
    key: "HowRevokeAlbum",
    title: "Как изъять альбом"
  },
  {
    key: "HowRevokeTrack",
    title: "Как изъять отдельный трек в альбоме"
  },
  {
    key: "HowEditTrackInAlbum",
    title: "Как отредактировать трек в опубликованном альбоме"
  },
  {
    key: "HowAddTrackInAlbum",
    title: "Как добавить трек в опубликованный альбом"
  },
  {
    key: "HowFindLinkOnAlbum",
    title: "Где найти ссылку на альбом"
  },
  {
    key: "VkClipsAndStories",
    title: "VK клипы и истории: как добавить трек в каталоги"
  },
  {
    key: "HowSpecifyArtistCardWhenPublish",
    title: "Как указать карточку артиста при публикации альбома/трека"
  },
  {
    key: "HowCreateNewArtistCard",
    title: "Как создать новую карточку артиста"
  },
  {
    key: "HowUploadVideo",
    title: "Как загрузить музыкальные видео"
  },
  {
    key: "HowAddLyrics",
    title: "Как добавить текст песни"
  },
  {
    key: "HowRevokeLyrics",
    title: "Как изъять текст песни"
  },
  // {
  //   key: "HowAddRights",
  //   title: "Как добавить авторские права"
  // },
  // {
  //   key: "HowRevokeRights",
  //   title: "Как изъять авторские права"
  // },
  {
    key: "StatisticsInfo",
    title: "Статистика и ТОП-100"
  },
  {
    key: "Faq",
    title: "FAQ"
  }
];
export const HelpPage: React.FC = () => {
  const { t } = useTranslation();
  useTitle(t("help"));
  const handleClickToSidebarItem = useCallback((id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return <>
    <div className={"mb-3"}>
        <span className={"font-bold text-3xl dark:text-white"}>
          {t("help")}
        </span>
    </div>

    <div className={"flex gap-4"}>
      <div className={"flex flex-col sidebar gap-1 text-sm max-h-[500px]"} style={{ position: "sticky", top: 30 }}>
        {SIDEBAR_ITEMS.map((item) => {
          return <>
            <div
              key={item.key}
              className={"py-2 p-2 bg-gray-100 text-gray-600 hover:bg-blue-100 cursor-pointer rounded"}
              onClick={() => handleClickToSidebarItem(item.key)}
            >
              {item.title}
            </div>
            {item.nested && item.nested.map(n => <div
              key={n.key}
              className={"ml-6 py-2 p-2 bg-gray-100 text-gray-600 hover:bg-blue-100 cursor-pointer rounded"}
              onClick={() => handleClickToSidebarItem(n.key)}
            >
              {n.title}
            </div>)}
          </>;
        })}
      </div>
      <div className={"flex flex-col gap-5 max-w-[800px]"}>
        <HowAddNewAlbum />
        <HowAddTracksInAlbum />

        <HowActionsWithRights />

        <HowRevokeAlbum />
        <HowRevokeTrack />

        <HowEditTrackInAlbum />
        <HowAddTrackInAlbum />

        <HowFindLinkOnAlbum />
        <VkClipsAndStories />

        <HowSpecifyArtistCardWhenPublish />
        <HowCreateNewArtistCard />

        <HowUploadVideo />

        {/*<HowAddRights />*/}
        {/*<HowRevokeRights />*/}

        <HowAddLyrics />
        <HowRevokeLyrics />

        <StatisticsInfo />
        <Faq />
      </div>
    </div>
  </>;
};
